import React from "react";
import { graphql, PreloadedQuery, usePreloadedQuery } from "react-relay";
import { WidgetSignalOverview } from "widgets";
import { WidgetAddSignalOverviewPreviewQuery } from "./__generated__/WidgetAddSignalOverviewPreviewQuery.graphql";

type Props = {
  query: PreloadedQuery<WidgetAddSignalOverviewPreviewQuery>;
};

export const WIDGET_ADD_SIGNAL_OVERVIEW_PREVIEW_QUERY = graphql`
  query WidgetAddSignalOverviewPreviewQuery(
    $storecastId: ID!
    $input: PreviewWidgetSignalOverviewInput!
  ) {
    dashboard(id: $storecastId) @required(action: THROW) {
      previewWidgetSignalOverview(input: $input) {
        ...WidgetSignalOverview_widget
      }
    }
  }
`;
export function WidgetAddSignalOverviewPreview(props: Props) {
  const data = usePreloadedQuery<WidgetAddSignalOverviewPreviewQuery>(
    WIDGET_ADD_SIGNAL_OVERVIEW_PREVIEW_QUERY,
    props.query
  );

  return (
    <WidgetSignalOverview
      mode="IDLE"
      interactive={false}
      widget={data.dashboard.previewWidgetSignalOverview}
      storecastId=""
    />
  );
}
